// App requirements
// SCSS
import * as scss from './app.scss';

// Common
import * as common from './js/common';

// Apps
import * as website from './js/website/website';
import * as cookie_banner from './js/website/cookie-banner';